import { render, staticRenderFns } from "./goodDetailSwiper.vue?vue&type=template&id=7ccbc3bb&scoped=true&"
import script from "./goodDetailSwiper.vue?vue&type=script&lang=js&"
export * from "./goodDetailSwiper.vue?vue&type=script&lang=js&"
import style0 from "./goodDetailSwiper.vue?vue&type=style&index=0&id=7ccbc3bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccbc3bb",
  null
  
)

export default component.exports